import React, { Component, useState, useEffect } from 'react';
// import Dropdown from 'react-bootstrap/Dropdown'
import { Button, Dropdown, Tab, Tabs, Nav } from 'react-bootstrap';
import InputField from '../../elements/Input';
import FilterChips from "./FilterChips";
import { useTranslation } from "react-i18next";
import MultiSelect from '../../elements/MultiSelect';
import { useParams } from 'react-router-dom';
import queryString from 'query-string';

const LeadListFilter = ({ callFilterReset ,filter_data, onSubmitFilter, statusOption}) => {
    const { t } = useTranslation('common');
    const [statusList, setStatusData] = useState([]);
    const [search_type, setSearchType] = useState("text");
    const [filterData, setFilterData] = useState(filter_data);
    const [tempFilterData, setTempFilterData] = useState(filter_data);
    let { status_id } = useParams();
    useEffect(() => {
        setStatusData(statusOption);
        setFilterOptionSelected();
    }, [statusOption]);

    const setFilterOptionSelected = async () => {
        const paramsData = queryString.parse(window.location.search);
        if (paramsData.search_text)
          filterData.search_text = paramsData.search_text;
        if(status_id){
            status_id=await status_id.split(',').map(v => Number(v));
            filterData.status_id=status_id;
        }
        setFilterData({ ...filterData });
        setTempFilterData({ ...filterData });
        onSubmitFilter(filterData);
      }


    const handleChangeMultiSel = (field_name, field_obj) => {
        let currval = [];
            currval = field_obj?.map(v => v.value);       
        filterData[field_name] = currval;
        // if(field_name==='status_id'){
        //     setStatusData(currval)
        // }
        setFilterData({...filterData});
    }
    const handleFilterChip = (field_name, field_obj) => {
        if(field_name == 'search_text'){
            filterData.search_text = '';
        }
        if(field_name == 'search_type'){
            filterData.search_type = '';
        }
        else if(field_name == 'status_id'){
            let index =filterData.status_id.indexOf(field_obj);
            if (index > -1) { 
                filterData.status_id.splice(index, 1);
            }
        }
        else if(field_name == 'updated_by'){
            let index =filterData.updated_by.indexOf(field_obj);
            if (index > -1) { 
                filterData.updated_by.splice(index, 1);
            }
        }
        setFilterData({...filterData});
        setTempFilterData({ ...filterData });
        filterChipCrossSubmit();
    }



    const filterChipCrossSubmit = ()=>{
        if (typeof onSubmitFilter === "function") {
            onSubmitFilter(filterData);
        }
    }
 
    const handleChangetext = event => {
        filterData[event.target.name] = event.target.value
            .replace(/[^\w\s]/gi, "")
            .replace("_", "");
        setFilterData({...filterData});
    }

    const handleChange = (field_name) => {
        filterData[field_name] = filterData?.is_unread === '1' ? '0' : '1';
        setFilterData({ ...filterData });
    }; 
 
    const submitFilterForm = event => {
        event.preventDefault();
        if (typeof onSubmitFilter === "function") {
            onSubmitFilter(filterData);
            setTempFilterData(Object.assign({}, filterData));
        }
    }

    const resetFilterForm = event => {
        setStatusData([]);
        setSearchType("text");
        filterData.source = "web";
        filterData.updated_by=[];
        filterData.status_id=[];
        delete filterData.search_text;
        delete filterData.is_unread;
        setFilterData(filterData);
        setTempFilterData({})
        callFilterReset();
        event.preventDefault();
        if (typeof onSubmitFilter === "function") {
            onSubmitFilter(filterData);
        }
    }
    return (
        <React.Fragment>
            <form onSubmit={submitFilterForm}>
                <div className="lead-list-filter">
                    <div className="filter-filed-form">
                        <fieldset className="single-select">
                            <div className="search-bx">
                                <input
                                    id="search_text"
                                    type={search_type}
                                    placeholder="Application Number, SFA User"
                                    name="search_text"
                                    autoComplete="off"
                                    value={
                                        filterData &&
                                            filterData.search_text
                                            ? filterData.search_text
                                            : ""
                                    }
                                    label="" 
                                    onChange={handleChangetext}
                                />
                                {/* <i className="ic-search"></i> */}
                            </div>
                        </fieldset>   

                        <fieldset className="form-filed">
                            <div className='loanbox-revmap-main'>
                            <div onClick={(e)=> handleChange('is_unread',e)} className="ToggleSwitch">
                                <div className={filterData?.is_unread === '1' ? 'knob active' : 'knob'} />
                                <div className="toggle-status">
                                    {filterData?.is_unread === '1' ? 'Unread' : ''}
                                </div>
                            </div>
                            </div>
                        </fieldset>
                    <div className="btn-submit-reset">
                          <button type='submit' className="btn-primary">Search</button>
                          <button onClick={resetFilterForm} className="btn-reset">Reset</button>
                    </div>            
                    </div>
                </div>
            </form>
           <FilterChips statusList = {statusList} 
       filterData = {tempFilterData} handleFilterChip = {handleFilterChip}/>                                                   
       </React.Fragment>
    )
}
export default LeadListFilter;